import { FC } from 'react';
import classnames from 'classnames';

import { Link } from 'dibs-elements/exports/Link';
import Eye from 'dibs-icons/exports/legacy/Eye';

import styles from './ShowPasswordButton.scss';

type Props = {
    isPasswordHidden: boolean;
    setIsPasswordHidden: (isPasswordHidden: boolean) => void;
};

const ShowPasswordButton: FC<Props> = ({ isPasswordHidden, setIsPasswordHidden }) => {
    return (
        <div
            className={classnames(styles.eyeIconWrapper, {
                [styles.eyeIconWrapperCrossedOut]: isPasswordHidden,
            })}
        >
            <Link
                className={styles.eyeIconButton}
                onClick={e => {
                    e.stopPropagation();
                    setIsPasswordHidden(!isPasswordHidden);
                }}
            >
                <Eye
                    noFill
                    className={classnames(styles.eyeIcon, {
                        [styles.eyeIconCrossedOut]: isPasswordHidden,
                    })}
                />
            </Link>
        </div>
    );
};

export default ShowPasswordButton;
